import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IClickablePanel } from '@shared/types/common.types';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit, IClickablePanel {
  @Input() triggerContent = $localize`Фильтр`;
  @Input() showActions: boolean;
  @Input() closeMenuEvent$;
  @Input() count$: Observable<number>;
  @Output() apply = new EventEmitter();
  @Output() clear = new EventEmitter();
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  childClick$ = new Subject<string>();

  constructor() {}

  ngOnInit(): void {
    if (this.closeMenuEvent$) {
      this.closeMenuEvent$.pipe(untilDestroyed(this)).subscribe({
        next: () => {
          this.trigger.closeMenu();
        },
      });
    }
  }

  closePanel() {
    this.trigger.closeMenu();
  }

  stopClick(event: Event) {
    this.childClick$.next('');
    event.stopPropagation();
  }

  clearClick() {
    this.clear.emit();
    this.trigger.closeMenu();
  }

  applyClick() {
    this.apply.emit();
    this.trigger.closeMenu();
  }
}
